/**
 * clipboard.js — copyTextToClipboard(text) -> boolean
 *
 * Clipboard write with a textarea/execCommand fallback for non-secure
 * contexts. Formerly duplicated verbatim (comment wording aside) in
 * LaunchPage.jsx and BuildValidationPanel.jsx; both bodies were confirmed
 * byte-for-byte equivalent before this extraction. Separate near-identical
 * copies still live in ChecksPage.jsx and
 * components/launch/CheckSpecPanel.jsx — out of scope for this dedup, left
 * untouched. Never throws.
 */
export function copyTextToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(String(text));
      return true;
    }
  } catch { /* fall through to legacy path */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = String(text);
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    document.execCommand('copy');
    ta.remove();
    return true;
  } catch { return false; }
}
